import React, { useRef, useState } from "react";
import toast from "react-hot-toast";
import { Image as ImageIcon, Upload, Link2 } from "lucide-react";
import { api, absUrl } from "../../lib/api";

export default function MediaPicker({ value, onChange }) {
  const [busy, setBusy] = useState(false);
  const [tab, setTab] = useState("upload");
  const [url, setUrl] = useState("");
  const fileRef = useRef();

  const onPick = async (e) => {
    const f = e.target.files?.[0];
    if (!f) return;
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", f);
      const r = await api.post("/admin/media/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      onChange(r.data.url);
      toast.success("Uploaded");
    } catch { toast.error("Upload failed"); } finally { setBusy(false); e.target.value = ""; }
  };

  return (
    <div className="border border-navy-900/15 p-3 bg-white">
      <div className="flex items-center gap-3">
        <div className="w-20 h-20 bg-ivory-200 border border-navy-900/10 overflow-hidden flex items-center justify-center shrink-0">
          {value ? <img src={absUrl(value)} className="w-full h-full object-cover" alt="" /> : <ImageIcon size={20} className="text-navy-900/30" />}
        </div>
        <div className="flex-1 space-y-2">
          <div className="flex gap-1">
            <button type="button" onClick={() => setTab("upload")} className={`text-[10px] tracking-[0.2em] uppercase px-3 py-1.5 border ${tab === "upload" ? "bg-navy-900 text-gold border-navy-900" : "border-navy-900/20"}`}>Upload</button>
            <button type="button" onClick={() => setTab("url")} className={`text-[10px] tracking-[0.2em] uppercase px-3 py-1.5 border ${tab === "url" ? "bg-navy-900 text-gold border-navy-900" : "border-navy-900/20"}`}>URL</button>
          </div>
          {tab === "upload" ? (
            <>
              <input ref={fileRef} type="file" accept="image/*,video/*" onChange={onPick} className="hidden" />
              <button type="button" onClick={() => fileRef.current?.click()} disabled={busy} className="btn-outline !py-2 !px-4 !text-[10px] w-full justify-center">
                <Upload size={12} /> {busy ? "Uploading…" : "Choose file"}
              </button>
            </>
          ) : (
            <div className="flex gap-2">
              <input className="input !py-2 !text-xs" placeholder="https://…" value={url} onChange={e => setUrl(e.target.value)} />
              <button type="button" onClick={() => { onChange(url); setUrl(""); }} className="btn-gold !py-2 !px-3 !text-[10px]"><Link2 size={12} /> Set</button>
            </div>
          )}
          {value && <button type="button" onClick={() => onChange("")} className="text-maroon text-[10px] tracking-[0.2em] uppercase hover:underline">Remove</button>}
        </div>
      </div>
    </div>
  );
}
